import { makeStyles } from '@policygenius/mortar';

interface Options {
  disabled?: boolean;
  selected?: boolean;
  highlighted?: boolean;
}

export default makeStyles((theme) => ({
  base: {
    padding: [theme.spacing('medium'), theme.spacing('large')],
    backgroundColor: ({ disabled, highlighted, selected }: Options) => {
      if (disabled) {
        return theme.colors.white;
      }
      if (highlighted) {
        return theme.colors.blue200;
      }
      if (selected) {
        return theme.colors.gray200;
      }

      return theme.colors.white;
    },
    '&:hover': {
      cursor: ({ disabled }: Options) => !disabled && 'pointer',
    },
  },
}));
